<template>
  <div class="container-fluid mt-5">
    <div class="row">
      <div class="col-xl-12 order-xl-1">
        <card>
          <div slot="header" class="row align-items-center">
            <div class="col-8">
              <h3 class="mb-0">
                {{ $t("SALES_PAYMENTS.ADD_SALES_PAYMENT") }}
              </h3>
            </div>
            <div class="col-4 text-right">
              <base-button
                @click="goBack"
                type="button"
                class="btn btn-sm btn-primary"
              >
                {{ $t("COMMON.RETURN_TO_LIST") }}
              </base-button>
            </div>
          </div>
          <div class="card-body">
            <salesPayment-form
              :loading="loading"
              :salesPaymentData="salesPayment"
              :formErrors="formErrors"
              @salesPaymentSubmitted="handleSubmit"
              @formChanged="() => (alertLeave = true)"
            />
          </div>
        </card>
      </div>
    </div>
  </div>
</template>

<script>
import { Select, Option } from "element-ui";
import { cloneDeep } from "lodash";
import alertLeave from "@/mixins/alert-leave-mixin";
import defaultSalesPayment from "./defaultSalesPayment";
import SalesPaymentForm from "./partials/SalesPaymentForm.vue";

export default {
  layout: "DashboardLayout",

  components: {
    [Select.name]: Select,
    [Option.name]: Option,
    SalesPaymentForm,
  },

  mixins: [alertLeave],

  data() {
    return {
      salesPayment: cloneDeep(defaultSalesPayment),
      formErrors: null,
      loading: false,
    };
  },

  created() {},

  methods: {
    goBack() {
      this.$router.push({ name: "List SalesPayments" });
    },

    viewSalesPayment(salesPayment) {
      this.alertLeave = false;
      this.$router.push({
        name: "View SalesPayment",
        params: { id: salesPayment.id },
      });
    },

    async handleSubmit(salesPaymentData) {
      this.loading = true;
      try {
        await this.$store.dispatch("salesPayments/add", salesPaymentData);
        this.$notify({
          type: "success",
          message: this.$t("SALES_PAYMENTS.SALES_PAYMENT_ADDED"),
        });
        const salesPayment = await this.$store.getters[
          "salesPayments/salesPayment"
        ];
        this.viewSalesPayment(salesPayment);
        this.loading = false;
      } catch (error) {
        this.$notify({
          type: "danger",
          message: this.$t("ERRORS.SOMETHING_WENT_WRONG"),
        });
        this.formErrors = error.response.data.errors;
        this.loading = false;
      }
    },
  },
};
</script>
